import React from 'react';
import clsx from 'clsx';
import {
    AppBar,
    Avatar,
    Box,
    Container,
    CssBaseline,
    Divider,
    Drawer,
    Hidden,
    IconButton,
    SvgIcon,
    TextField,
    Toolbar,
    Typography,
} from "@material-ui/core";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
import useStyles from '../styles/styles';
import {MainListItems} from './listItems';
import {navigate, Router} from '@reach/router';
import PingTrees from './PingTrees';
import Campaign from '../routes/Campaign';
import PostingInstructions from "./PostingInstructions";
import DNPPostingInstructions from "./DNPPostingInstructions";
import Leads from '../routes/Leads'
import DashMain from "../routes/DashMain";
import {useAuth} from "../auth/Auth";
import GoogleLogin, {GoogleLogout} from "react-google-login";
import ProtectedRoute from "../auth/ProtectedRoute";
import Home from "../routes/Home";
import Lead from "../routes/Lead";
import TrafficSources from "../routes/TrafficSources";
import TrafficSource from "../routes/TrafficSource";
import Affiliates from "../routes/Affiliates";
import AddTrafficSource from '../routes/AddTrafficSource';
import LoanRequestLog from "../routes/LoanRequestLog";
import LeadsTestingTool from '../routes/LeadsTestingTool';
import Campaigns from "../routes/Campaigns";
import CampaignCapacities from "../routes/CampaignCapacities";
import VendorPauses from "../routes/VendorPauses";
import BlockedSources from "../routes/BlockedSources";
import JvmStats from "../routes/JvmStats";
import AMPPostingInstructions from "../routes/AMPPostingInstructions";
import Configs from "../routes/Configs";
import Servicers from "../routes/Servicers";
import Servicer from "../routes/Servicer";
import CampaignFilterLists from "../routes/CampaignFilterLists";
import LenderFeedbackPostingInstructions from "./LenderFeedbackPostingInstructions";
import RevenueItems from "../routes/RevenueItems";
import RevenueItem from "../routes/RevenueItem";
import AddRevenueItem from "../routes/AddRevenueItem";
import Companies from "../routes/Companies";
import Company from '../routes/Company';
import AddCompany from '../routes/AddCompany';
import Pixels from '../routes/Pixels';
import Pixel from '../routes/Pixel';
import AddPixel from '../routes/AddPixel';
import PixelLog from '../routes/PixelLog';
import LeadPurchasePostingInstructions from "./LeadPurchasePostingInstructions";
import LeadPurchaseV2PostingInstructions from "./LeadPurchaseV2PostingInstructions";
import LeadPurchaseRequests from "../routes/LeadPurchaseRequests";
import LeadPurchaseRequest from "../routes/LeadPurchaseRequest";
import ListManagementPostingInstructions from "./ListManagementPostingInstructions";
import SignatureBlocks from "../routes/SignatureBlocks";
import OptOuts from "../routes/OptOuts";
import TrafficSourceStateGroups from "../routes/TrafficSourceStateGroups";
import Advertiser from '../routes/Advertiser';
import Offers from '../routes/Offers';
import Offer from '../routes/Offer';
import FrontendConfig from "../routes/FrontendConfig";
import OfferEventApiPostingInstructions from "./OfferEventApiPostingInstructions";
import Websites from "../routes/Websites";
import ExperianPrefillApiPostingInstructions from "./ExperianPrefillApiPostingInstructions";
import SsnHash from "../routes/SsnHash";
import SetPromoId from "../routes/SetPromoId";
import ShortFormLead from "../routes/ShortFormLead";
import ShortFormLeads from "../routes/ShortFormLeads";
import {BuyerRouting} from "../routes/BuyerRouting";
import PayoutStrategySwappers from "../routes/PayoutStrategySwappers";

function AcquireInteractiveLogo(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 706.18 166.22">
            <path fill="#da5a27"
                  d="M114.31 100.2l30.81-.29-31.42-43.06-.72-39.1L96.18 0 74.29 16.61l.21 43.38zM146.22 110.94l-55.4 11.5-16.53 26 53.22-2.91 33.18 20.69 24.04-4.43-.7-25.95zM64.99 65.86l-23.13 48.01-34.14 19.09L0 156.15l25.93 10.07 37.19-19.27 16.67-54.07z"/>
            <path fill="#808285"
                  d="M180.87 78.33l22.16-63.19h12.1l22.16 63.19h-11.75l-5.43-16.2h-22.16l-5.34 16.2h-11.74zm19.94-25.55h16.47l-5.61-16.91-2.49-9.79H209c-.95 4.16-1.78 7.42-2.49 9.79l-5.7 16.91zM263.73 46.46c0-9.25 3.06-16.97 9.17-23.14 6.11-6.17 13.88-9.26 23.32-9.26 9.61 0 17.39 2.88 23.32 8.63l-5.52 8.54c-2.31-1.96-5.03-3.56-8.14-4.81-3.12-1.25-6.16-1.87-9.12-1.87-6.65 0-11.84 2.08-15.58 6.23s-5.61 9.32-5.61 15.49c0 6.23 1.9 11.56 5.7 15.98 3.8 4.42 8.99 6.63 15.58 6.63 6.76 0 12.87-2.67 18.33-8.01l6.05 8.28c-6.71 6.82-14.98 10.24-24.83 10.24-9.79 0-17.68-3.12-23.67-9.35-6-6.22-9-14.08-9-23.58zM348.91 46.38c0-9.14 3.08-16.81 9.26-23.01 6.17-6.2 13.97-9.3 23.41-9.3 9.49 0 17.31 3.09 23.46 9.26 6.14 6.17 9.21 13.86 9.21 23.05 0 7.36-2.31 14.03-6.94 20.03l7.12 6.41-6.59 7.3-6.94-6.94c-5.52 4.15-11.96 6.23-19.31 6.23-9.43 0-17.24-3.17-23.41-9.53-6.18-6.36-9.27-14.19-9.27-23.5zm11.84 0c0 6.41 1.99 11.76 5.96 16.07 3.97 4.3 8.93 6.45 14.86 6.45 4.27 0 7.95-1.13 11.04-3.38l-7.03-6.59 6.5-7.21 6.85 6.85c2.32-3.62 3.47-7.68 3.47-12.19 0-6.23-1.99-11.42-5.96-15.58-3.97-4.15-8.93-6.23-14.86-6.23s-10.89 2.08-14.86 6.23c-3.98 4.15-5.97 9.34-5.97 15.58zM448.24 55.63v-40.5h11.48v40.41c0 4.21 1.26 7.49 3.78 9.83 2.52 2.34 5.92 3.52 10.19 3.52s7.67-1.17 10.19-3.52c2.52-2.34 3.78-5.62 3.78-9.83v-40.4h11.48v40.5c0 7.06-2.33 12.79-6.99 17.18-4.66 4.39-10.78 6.59-18.38 6.59-7.66 0-13.83-2.2-18.51-6.59-4.68-4.4-7.02-10.13-7.02-17.19zM536.89 78.33V15.14h11.48v63.19h-11.48zM586.82 78.33V15.14h20.83c5.34 0 9.31.56 11.93 1.69 3.32 1.37 5.93 3.53 7.83 6.5 1.9 2.97 2.85 6.56 2.85 10.77 0 3.86-.95 7.37-2.85 10.55-1.9 3.18-4.48 5.42-7.74 6.72v.18c.53.65 1.22 1.75 2.05 3.29l13 23.5H621.8l-12.46-23.59H598.3v23.59h-11.48zm11.49-33.56h10.32c3.08 0 5.52-.91 7.3-2.72 1.78-1.81 2.67-4.26 2.67-7.34 0-4.39-1.66-7.27-4.99-8.63-1.6-.71-3.92-1.07-6.94-1.07h-8.37v19.76zM666.93 78.33V15.14h37.83v9.88h-26.34v16.56h21.27v9.88h-21.27v17h27.77v9.88h-39.26zM276.65 144.75v-35.37h6.43v35.37h-6.43zM294.38 144.75v-35.37h6.43l13.4 20.42c.4.63.84 1.4 1.32 2.32.48.91.87 1.67 1.17 2.27l.45.89h.1c-.23-2.26-.35-4.09-.35-5.48v-20.42h6.38v35.37h-6.38l-13.4-20.37c-.4-.63-.84-1.4-1.32-2.32-.48-.91-.87-1.67-1.17-2.27l-.45-.9h-.1c.23 2.26.35 4.08.35 5.48v20.37h-6.43zM342.65 144.75v-29.84h-11.61v-5.53h29.59v5.53h-11.61v29.84h-6.37zM368.35 144.75v-35.37h21.17v5.53h-14.75v9.26h11.91v5.53h-11.91v9.51h15.54v5.53h-21.96zM399.39 144.75v-35.37h11.66c2.99 0 5.21.32 6.67.95 1.86.77 3.32 1.98 4.38 3.64 1.06 1.66 1.59 3.67 1.59 6.03 0 2.16-.53 4.13-1.59 5.91-1.06 1.78-2.51 3.03-4.33 3.76v.1c.3.37.68.98 1.14 1.84l7.27 13.15h-7.22l-6.97-13.2h-6.18v13.2h-6.42zm6.42-18.78h5.78c1.73 0 3.09-.51 4.09-1.52s1.49-2.38 1.49-4.11c0-2.46-.93-4.07-2.79-4.83-.9-.4-2.19-.6-3.88-.6h-4.68v11.06zM430.12 144.75l12.4-35.37h6.77l12.4 35.37h-6.58l-3.04-9.07h-12.4l-2.99 9.07h-6.56zm11.16-14.3h9.22l-3.14-9.46-1.39-5.48h-.1c-.53 2.33-.99 4.15-1.39 5.48l-3.2 9.46zM466.29 126.91c0-5.18 1.71-9.5 5.13-12.95 3.42-3.45 7.77-5.18 13.05-5.18 5.38 0 9.73 1.61 13.05 4.83l-3.09 4.78c-1.29-1.09-2.81-1.99-4.56-2.69-1.74-.7-3.44-1.05-5.11-1.05-3.72 0-6.62 1.16-8.72 3.49-2.09 2.32-3.14 5.21-3.14 8.67 0 3.49 1.06 6.47 3.19 8.94 2.13 2.47 5.03 3.71 8.72 3.71 3.79 0 7.21-1.49 10.26-4.48l3.39 4.63c-3.75 3.82-8.38 5.73-13.9 5.73-5.48 0-9.9-1.74-13.25-5.23-3.34-3.48-5.02-7.88-5.02-13.2zM514.75 144.75v-29.84h-11.61v-5.53h29.59v5.53h-11.61v29.84h-6.37zM540.46 144.75v-35.37h6.42v35.37h-6.42zM566.91 144.75l-12.75-35.37h6.92l7.77 23.06 1.34 5.18h.1c.47-2.09.91-3.82 1.34-5.18l7.87-23.06h6.82l-12.75 35.37h-6.66zM593.61 144.75v-35.37h21.17v5.53h-14.74v9.26h11.91v5.53h-11.91v9.51h15.54v5.53h-21.97z"/>
        </SvgIcon>
    );
}

function Copyright() {
    return (
        <Box paddingTop={2}>
            <Typography variant="body2" color="textSecondary" align="center" paragraph>
                Copyright &copy; 2019&ndash;{new Date().getFullYear()} Acquire Interactive, LLC.
            </Typography>
            <TextField id="jwt" label="Current JWT" variant="outlined" value={useAuth().getIdToken()}/>
        </Box>
    );
}

export default function Dashboard() {
    const auth = useAuth();
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    /**
     * The response on success is a GoogleUser object.
     * @see https://developers.google.com/identity/sign-in/web/reference#users
     * @param response
     */
    const populateContext = response => {
        auth.setUser(response);
        // console.log('onsuccess', response)
        // console.log(response.isSignedIn())
        // console.log('scopes', response.getGrantedScopes())
        // console.log('domains', response.getHostedDomain())
    }

    const logError = response => {
        // console.log('onsuccess', response)
        // console.log(response.isSignedIn())
        // console.log('scopes', response.getGrantedScopes())
        // console.log('domains', response.getHostedDomain())
    }

    const UserSection = props => {
        if (auth.isSignedIn()) {
            return (
                <>
                    <Hidden only="xs">
                        <Typography variant="h6" noWrap>{`Hi, ${auth.getGivenName()}`}</Typography>
                    </Hidden>
                    <GoogleLogout
                        clientId="1082820419159-nlbj8sfe8amtmpjb7fb967g3mcotusci.apps.googleusercontent.com"
                        onLogoutSuccess={() => {
                            auth.setUser(null);
                            localStorage.clear();
                            navigate('/info');
                            window.location.reload();
                        }}
                        render={renderProps => (<IconButton edge="end" color="inherit" onClick={renderProps.onClick}>
                            <Avatar src={auth.getImageUrl()}/>
                        </IconButton>)
                        }
                    />
                </>
            )
        }

        return (<GoogleLogin
            cookiePolicy={'single_host_origin'}
            buttonText="Login"
            onSuccess={populateContext}
            onFailure={logError}
            clientId="1082820419159-nlbj8sfe8amtmpjb7fb967g3mcotusci.apps.googleusercontent.com"
        />)
    }
    const host = window.location.host;
    const env = host.includes('test') || host.includes('localhost') ? 'test' : 'prod';
    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={env === 'prod' ? classes.toolbar : classes.testToolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(open && classes.hidden)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <AcquireInteractiveLogo className={clsx(classes.logoWhite, open && classes.hidden)}/>
                    <UserSection/>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <Box component="div" className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon/>
                    </IconButton>
                    <AcquireInteractiveLogo className={classes.logo}/>
                </Box>
                <Divider/>
                <MainListItems drawerOpen={open} handleDrawerOpen={handleDrawerOpen} />
            </Drawer>
            <main className={classes.content}>
                <Container maxWidth="xl" className={classes.container}>
                    <Router primary={false}>
                        <Home path="/"/>
                        <ProtectedRoute as={DashMain} path="dashboard"/>
                        <ProtectedRoute as={Pixels} path="pixels"/>
                        <ProtectedRoute as={Pixel} path="pixels/:pixelId"/>
                        <ProtectedRoute as={AddPixel} path="pixels/add"/>
                        <ProtectedRoute as={PixelLog} path="pixel-log"/>
                        <ProtectedRoute as={Companies} path="companies"/>
                        <ProtectedRoute as={Company} path="companies/:companyId"/>
                        <ProtectedRoute as={AddCompany} path="companies/add"/>
                        <ProtectedRoute as={RevenueItems} path="revenueitems"/>
                        <ProtectedRoute as={RevenueItem} path="revenueitems/:revenueId"/>
                        {/*<ProtectedRoute as={AddRevenueItem} path="revenueitems/add"/>*/}
                        <ProtectedRoute as={CampaignFilterLists} path="campaign-filter-lists"/>
                        <ProtectedRoute as={JvmStats} path="jvm-stats"/>
                        <ProtectedRoute as={Configs} path="configs"/>
                        <ProtectedRoute as={Servicers} path="servicers"/>
                        <ProtectedRoute as={Servicer} path="servicers/:servicerId"/>
                        <ProtectedRoute as={Campaigns} path="campaigns"/>
                        <ProtectedRoute as={Campaign} path="campaigns/:campaignId"/>
                        <ProtectedRoute as={CampaignCapacities} path="campaign-capacities"/>
                        <ProtectedRoute as={PingTrees} path="pingtrees"/>
                        <ProtectedRoute as={Leads} path="leads"/>
                        <ProtectedRoute as={ShortFormLeads} path="leads/short"/>
                        <ProtectedRoute as={Lead} path="leads/:leadId"/>
                        <ProtectedRoute as={ShortFormLead} path="leads/short/:leadId"/>
                        <ProtectedRoute as={LoanRequestLog} path="loan-request-log"/>
                        <ProtectedRoute as={TrafficSources} path="traffic-sources"/>
                        <ProtectedRoute as={TrafficSource} path="traffic-sources/:trafficSourceId"/>
                        <ProtectedRoute as={AddTrafficSource} path="traffic-sources/add"/>
                        <ProtectedRoute as={AddTrafficSource} path="traffic-sources/add/offerId/:offerId"/>
                        <ProtectedRoute as={BlockedSources} path="blocked-sources"/>
                        <ProtectedRoute as={Affiliates} path="affiliates"/>
                        <ProtectedRoute as={PayoutStrategySwappers} path="payout-strategy-swappers"/>
                        <ProtectedRoute as={LeadsTestingTool} path="leads-testing-tool"/>
                        <ProtectedRoute as={VendorPauses} path="vendor-pause"/>
                        <ProtectedRoute as={LeadPurchaseRequests} path="lead-purchase-requests"/>
                        <ProtectedRoute as={LeadPurchaseRequest} path="lead-purchase-requests/:leadPurchaseRequestId"/>
                        <ProtectedRoute as={SignatureBlocks} path="signature-blocks"/>
                        <ProtectedRoute as={TrafficSourceStateGroups} path="traffic-source-state-groups"/>
                        <ProtectedRoute as={Advertiser} path="advertisers"/>
                        <ProtectedRoute as={Offers} path="offers"/>
                        <ProtectedRoute as={Offers} path="offers/advertiser/:advertiserId"/>
                        <ProtectedRoute as={Offer} path="offers/:offerId"/>
                        <ProtectedRoute as={Offer} path="offers/add"/>
                        <ProtectedRoute as={Websites} path="websites"/>
                        {/*<ProtectedRoute as={BuyerRouting} path="buyer-routing"/>*/}
                        <ProtectedRoute as={OptOuts} path="opt-outs"/>
                        <ProtectedRoute as={SsnHash} path="ssn-hash"/>
                        <ProtectedRoute as={SetPromoId} path="set-promo-id"/>
                        <ProtectedRoute as={FrontendConfig} path="frontend-config"/>
                        <DNPPostingInstructions path="dnp-posting"/>
                        <PostingInstructions path="posting"/>
                        <AMPPostingInstructions path="amp-docs"/>
                        <LenderFeedbackPostingInstructions path="lender-feedback-docs"/>
                        <LeadPurchasePostingInstructions path="lead-purchase-posting"/>
                        <LeadPurchaseV2PostingInstructions path="lead-purchase-v2-posting"/>
                        <OfferEventApiPostingInstructions path="offer-event-api-posting"/>
                        <ListManagementPostingInstructions path="list-management-posting"/>
                        <ExperianPrefillApiPostingInstructions path="experian-prefill-posting"/>
                    </Router>
                    <Copyright/>
                </Container>
            </main>
        </div>
    );
}
